import { Table as EventItemsTable } from '@/components/event_item/table'

interface Props {
  eventId: string
}

export const EditKit = ({ eventId }: Props) => {
  return (
    <>
      <EventItemsTable eventId={eventId} pageSize={10} title="Kit" createable fixedHeight updateable />
    </>
  )
}
